<template>
    <section class="init_box" style="background-color:white">
        <el-row style="padding-top:10px">
            <el-col :span="3">
                <div>
                    <!-- <el-button size="small" type="primary" class="btn">添加设备</el-button> -->
                    <el-button size="small" type="primary" class="btn">导出台账</el-button>
                </div>
            </el-col>
            <el-col :span="21" >
                <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline" style="float: right;">
                    <el-form-item label="项目">
                        <el-input v-model="deviceInfo.projectName" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="试验室">
                        <el-select v-model="deviceInfo.company" filterable clearable placeholder="请选择试验室">
                            <el-option v-for="item in companyData" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备状态">
                        <el-select v-model="deviceInfo.statue" filterable clearable placeholder="请选择状态" style="width:140px">
                            <el-option v-for="item in statueData" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                            <!-- <option value="在用">在用</option>
                            <option value="待审核">待审核</option>
                            <option value="待检定">待检定</option>
                            <option value="已调拨">已调拨</option>
                            <option value="已报废">已报废</option> -->
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="日期">
                        <el-date-picker v-model="deviceInfo.date" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item> -->
                    <el-form-item>
                        <el-input v-model="deviceInfo.neirong" auto-complete="off" placeholder="请输入搜索内容"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-table :data="tableData" :header-cell-style="{ background: '#eff3f6' }" stripe style="width: 100%;text-align: center;">
                    <el-table-column type="index" label="序号" width="80">  
                        <template slot-scope="scope">
                            <span>{{ scope.$index + (pageIndex - 1) * pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="">
                                {{ scope.row.zcmc }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="">
                                {{ scope.row.glbh }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="sydw" label="使用部门" show-overflow-tooltip :formatter="formateCompany">
                    </el-table-column>
                    <el-table-column prop="syr" label="使用人" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="bgr" label="保管人" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="sbzt" label="设备状态" show-overflow-tooltip :formatter="formateStatue">
                    </el-table-column>
                    <el-table-column label="操作" width="120" style="text-decoration: none;">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="clickMenu(scope.row)">
                                详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <!--分页工具条-->
            <el-col :span="24" class="toolbar" style="margin-top:15px">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 50, 100]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
                    :total="total" style="float:right">
                </el-pagination>
            </el-col>
        </el-row>
    </section>
</template>
<script>
import { getDeviceByCompany,getSysByCompanyCode,getStatueByDevice } from '../../api/api';
export default {
    data() {
        return {
            total: 0,
            pageIndex: 1,
            pageSize:10,
            deviceInfo:{
                projectName:sessionStorage.getItem('projectName'),
                department:sessionStorage.getItem('company'),
                statue:'',
                date:'',
                neirong:''
            },
            statues: [],
            tableData:[],
            totalData:[],
            companyData:[],
            statueData:[]
        }
    },
    methods:{
        handleCurrentChange(val) {
            this.pageIndex = val;
            // this.getDataList();
            this.tableData = this.totalData.slice(
                (this.pageIndex - 1) * this.pageSize,
                this.pageIndex * this.pageSize
            );
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.tableData = this.totalData.slice(
                (this.pageIndex - 1) * this.pageSize,
                this.pageIndex * this.pageSize
            );
        },
        // 根据试验室查找设备
        getDevice(){
            let _params={
                companyCode:sessionStorage.getItem('company')
            }
            getDeviceByCompany(_params).then(datas=>{
                let {data,message,status}=datas
                if(status==200){
                    this.total=data.length
                    this.tableData = data.slice(0,this.pageSize);
                    this.totalData=data
                }
            })
        },
        // 查找试验室
        getCompanyData(){
            let _params={
                companyId:sessionStorage.getItem('company'),
            }
            getSysByCompanyCode(_params).then(datas=>{
                let {data,message,status}=datas
                if(status==200){
                    for(var i=0;i<data.length;i++){
                        this.companyData.push({label:data[i].companyName,value:data[i].companyCode})
                    }
                }
            })
        },
        // 获取设备状态
        getStatue(){
            getStatueByDevice().then(datas=>{
                let {data,status,message}=datas
                if(status==200){
                    for(var i=0;i<data.length;i++){
                        if(data[i].id!=3&&data[i].id!=4){
                            this.statueData.push({label:data[i].statusName,value:data[i].id})
                        }
                    }
                   
                }
            })
        },
        // 格式化部门
        formateCompany(row){
            let companyName=""
            for(var i=0;i<this.companyData.length;i++){
                if(row.sydw==this.companyData[i].value){
                    companyName=this.companyData[i].label
                }
            }
            return companyName
        },
        formateStatue(row){
            let statueName=""
            for(var i=0;i<this.statueData.length;i++){
                if(row.sbzt==this.statueData[i].value){
                    statueName=this.statueData[i].label
                }
            }
            return statueName
        },
        
    },
    created() {
        this.getCompanyData()
        this.getStatue()
        this.getDevice()
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/device/ProjectInfo_device.vue